import { keepPreviousData, useQuery } from '@tanstack/react-query';

import {
  vehicleDetailQuery,
  vehicleFacetsQuery,
  vehicleListQuery,
  vehicleMediaQuery,
} from '@/services/vehicles/queries';
import { type VehicleListFilters } from '@/services/vehicles/types';

export function useVehicleList(filters: VehicleListFilters) {
  // Keep the previous page on screen while the next one loads.
  return useQuery({ ...vehicleListQuery(filters), placeholderData: keepPreviousData });
}

export function useVehicle(slug: string) {
  return useQuery(vehicleDetailQuery(slug));
}

export function useVehicleMedia(listingId: string | undefined) {
  return useQuery({ ...vehicleMediaQuery(listingId ?? ''), enabled: Boolean(listingId) });
}

export function useVehicleFacets() {
  return useQuery(vehicleFacetsQuery());
}
